<template>
	<svg :class="svgClass" aria-hidden="true">
		<use :xlink:href="iconName" />
	</svg>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	iconClass: {
		type: String,
		required: true
	},
	className: {
		type: String,
		default: ''
	}
});

// 计算 iconName
const iconName = computed(() => `#icon-${props.iconClass}`);

// 计算 svgClass
const svgClass = computed(() => {
	return props.className ? 'svg-icon ' + props.className : 'svg-icon';
});
</script>

<style scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>
